import { ForkEffect, takeEvery } from 'redux-saga/effects';
import { Socket } from 'socket.io-client';

import { send } from '../send-request';
import {
  namesUpdate,
  nameUpdate,
  nameValueUpdate,
  propertyLoad,
  propertySaveWarehouseProperties,
  saveCategoriesUUIDs,
  updateType,
  updateUnit,
  updateValueNames,
} from './reducer';

export function* watch(
  socket: Socket,
): Generator<ForkEffect<never>, void, string> {
  yield takeEvery(propertyLoad.type, send, socket);
  yield takeEvery(saveCategoriesUUIDs.type, send, socket);
  yield takeEvery(propertySaveWarehouseProperties.type, send, socket);
  yield takeEvery(nameUpdate.type, send, socket);
  yield takeEvery(namesUpdate.type, send, socket);
  yield takeEvery(updateType.type, send, socket);
  yield takeEvery(updateUnit.type, send, socket);
  yield takeEvery(nameValueUpdate.type, send, socket);
  yield takeEvery(updateValueNames.type, send, socket);
}
